// The first message a socket receives after connecting: which build is
// answering, the server's clock, and — since the handshake is authenticated
// (slice 02) — who the server takes the connection to be. It exists so a
// client can show, and a spec can assert, that the WebSocket path through
// nginx works end to end and that the socket knows the person by handle.
export const HELLO_EVENT = 'hello';
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Validate an inbound `hello`. A message is data from the wire, never trusted:
 * anything but the exact shape reads as null, so a caller can only ever act on
 * a well-formed greeting.
 */
export function parseHello(value) {
    if (typeof value !== 'object' || value === null)
        return null;
    const { commit, serverTime, user } = value;
    if (typeof commit !== 'string' || commit.length === 0 || commit.length > 64)
        return null;
    if (typeof serverTime !== 'string' || Number.isNaN(Date.parse(serverTime)))
        return null;
    if (typeof user !== 'object' || user === null)
        return null;
    const { id, handle } = user;
    if (typeof id !== 'string' || !UUID_RE.test(id))
        return null;
    if (handle !== null && (typeof handle !== 'string' || handle.length === 0 || handle.length > 64))
        return null;
    return { commit, serverTime, user: { id, handle } };
}
//# sourceMappingURL=hello.js.map